$(document).ready(() => {
    const currentCulture = $('body').data('currentCulture');
    const siteId = $('body').data('siteId');
    var alleQuestionIdListe: any = [], alleCategoryIdListe: any = [];

    $('.collapsible-button').each(function() {
        alleQuestionIdListe.push($(this).attr('data-questionId'));
    });

    $('.faq-kategori-wrapper').each(function () {
        alleCategoryIdListe.push($(this).attr('data-kategori'));
    });

    $(".collapsible-button").click(function() {
        $(this).parent().toggleClass("faq-collapse-shown");
    });

    $('.dropdown-item:not(#filtering-show-all)').click(function() {
        visKategoriOgGemAndre($(this).attr("data-kategoriId"));
        $('.ingen-resultater-container').slideUp("fast");

        const currentCategory = $('#currentFaqCategory');
        currentCategory.html($(this).text());
        currentCategory.addClass('faq-active');
    });

    $('#filtering-show-all').click(function() {
        $('#currentFaqCategory').html($(this).text() as string).addClass('faq-active');
        $('.ingen-resultater-container').slideUp("fast");
        lukAlleQuestions();
        alleCategoryIdListe.forEach((id: any) => {
            visKategori(id);
        });
    });

    $('#search-input').keyup(function (e) {
        $('#currentFaqCategory').html($('#dropdown-placeholder').val() as string).removeClass('faq-active');
        const searchQuery = $(this).val() as string;
        if (searchQuery.trim().length < 2) {
            if (searchQuery.trim() === "") {
                alleCategoryIdListe.forEach((id: any) => {
                    visKategori(id);
                });
            }
            lukAlleQuestions();
            $('.ingen-resultater-container').slideUp("fast");
            return;
        }

        $.ajax({
            url: `/umbraco/api/faq/getmatchingquestions?siteId=${siteId}&currentCulture=${currentCulture}&query=${searchQuery}`,
            success(result) {
                if (result.length === 0) {
                    lukAlleQuestions();
                    lukAlleKategorier();
                    $('.ingen-resultater-container').slideDown("fast");
                    return;
                }

                $('.ingen-resultater-container').slideUp("fast");

                result.forEach((match: any) => {
                    visKategori(match.CategoryId);
                    visCollapsible(match.QuestionId);
                });
                lukAlleKategorierOgCollapsibleUdenMatch(alleQuestionIdListe, alleCategoryIdListe, result.map((o: any) => o.QuestionId), result.map((x: any) => x.CategoryId));
            }
        });
    });
});

const visKategori = (kategoriId: string) => {
    const selectedCategory = $("div[data-kategori='" + kategoriId + "']");
    selectedCategory.slideDown("fast");
}

const skjulKategori = (kategoriId: string) => {
    const selectedCategory = $("div[data-kategori='" + kategoriId + "']");
    selectedCategory.slideUp("fast");
}

const visKategoriOgGemAndre = (kategoriId: string) => {
    const selectedCategory = $("div[data-kategori='" + kategoriId + "']");

    lukAlleQuestions();
    $(".faq-kategori-wrapper").not(selectedCategory).slideUp("fast");
    selectedCategory.slideDown("fast");
}

const lukAlleKategorier = () => {
    $(".faq-kategori-wrapper").slideUp("fast");
}

const lukAlleQuestions = () => {
    $(".collapsible-button").each(function() {
        if ($(this).attr("aria-expanded") === "true") {
            $(this).click();
        }
    });
}

const lukAlleKategorierOgCollapsibleUdenMatch = (alleQuestionIdListe: any, alleCategoryIdListe: any, matchendeQuestionIds: any, matchendeCategoryId: any) => {
    var ingenQuestionIdMatchListe: any = [];
    alleQuestionIdListe.forEach((questionId: any) => {
        if (matchendeQuestionIds.indexOf(Number(questionId)) === -1) {
            ingenQuestionIdMatchListe.push(questionId);
        }
    });

    ingenQuestionIdMatchListe.forEach((ingenMatch: any) => {
        lukCollapsible(ingenMatch);
    });

    var ingenCategoryIdMatchListe: any = [];
    alleCategoryIdListe.forEach((categoryId: any) => {
        if (matchendeCategoryId.indexOf(Number(categoryId)) === -1) {
            ingenCategoryIdMatchListe.push(categoryId);
        }
    });

    ingenCategoryIdMatchListe.forEach((ingenMatch: any) => {
        skjulKategori(ingenMatch);
    });
}

const visCollapsible = (questionId: string) => {
    const selectedQuestion = $("a[data-questionId='" + questionId + "']");

    if (selectedQuestion.attr("aria-expanded") === "false") {
        selectedQuestion.click();
    }
}

const lukCollapsible = (questionId: string) => {
    const selectedQuestion = $("a[data-questionId='" + questionId + "']");

    if (selectedQuestion.attr("aria-expanded") === "true") {
        selectedQuestion.click();
    }
}





// WEBPACK FOOTER //
// ./Content/scripts/pages/faq.ts